import HttpCliente from "../servicios/HttpCliente";

export const insertarMantenedorUnOrganizacional = async (payload) => {
    return await HttpCliente.post("/UnidadesOrganizacionales", payload);
};

export const actualizarMantenedorUnOrganizacional = async (payload) => {
    return await HttpCliente.put("/UnidadesOrganizacionales", payload);
};

export const obtenerMantenedorUnOrganizacional = async () => {
    return await HttpCliente.get("/UnidadesOrganizacionales");
};